import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { ME_CONSENT_EXHIBITOR_ANSWER } from '@graphql/operations/user/meConsentExhibitorAnswer';
import useLocaleForQueries from '@hooks/useLocaleForQueries';
import { UPDATE_CONSENT_ANSWER } from '@graphql/operations/consent/updateConsentAnswer';
import ExhibitorConsentModal from './ExhibitorConsentModal';

export const ExhibitorConsent = ({
  attendeeId,
  id,
  questionText,
  optInId,
  optInText,
  optOutId,
  optOutText,
  title,
  onAnswer
}) => {
  const [submitConsentAnswer] = useMutation(UPDATE_CONSENT_ANSWER);

  const [selectedOption, setSelectedOption] = useState(null);
  const locale = useLocaleForQueries();

  const handleOptionUpdate = value => {
    setSelectedOption(value);
  };

  const onAnswerSubmit = () => {
    let choiceAnswer = { id: optInId, text: optInText };
    const consentAnswerUpdateRequest = {
      questionId: id,
      questionText,
      locale
    };
    if (selectedOption === optOutId) {
      choiceAnswer = { id: optOutId, text: optOutText };
    }
    consentAnswerUpdateRequest.choiceAnswer = { ...choiceAnswer };
    submitConsentAnswer({
      variables: { consentAnswer: consentAnswerUpdateRequest },
      optimisticResponse: {
        __typename: 'User',
        id: attendeeId,
        updateExhibitorConsentAnswer: {
          answer: {
            questionId: consentAnswerUpdateRequest.questionId,
            attendeeId,
            questionText: consentAnswerUpdateRequest.questionText,
            answerId: '',
            choice: {
              id: consentAnswerUpdateRequest.choiceAnswer.id,
              text: consentAnswerUpdateRequest.choiceAnswer.text,
              __typename: 'ExhibitorConsentChoiceAnswerResponse'
            },
            locale,
            __typename: 'ExhibitorConsentAnswer'
          },
          __typename: 'ExhibitorConsentAnswerResponse'
        }
      },
      update(cache, { data: { updateExhibitorConsentAnswer } }) {
        cache.writeQuery({
          query: ME_CONSENT_EXHIBITOR_ANSWER,
          data: {
            me: {
              __typename: 'User',
              id: attendeeId,
              exhibitorConsentAnswer: {
                ...updateExhibitorConsentAnswer.answer
              }
            }
          }
        });
      }
    });
    onAnswer();
  };

  return (
    <ExhibitorConsentModal
      title={title}
      questionText={questionText}
      optInId={optInId}
      optInText={optInText}
      optOutId={optOutId}
      optOutText={optOutText}
      selectedOption={selectedOption}
      handleUpdate={handleOptionUpdate}
      onAnswer={onAnswerSubmit}
    />
  );
};

ExhibitorConsent.propTypes = {
  attendeeId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  questionText: PropTypes.string.isRequired,
  optInId: PropTypes.string.isRequired,
  optInText: PropTypes.string.isRequired,
  optOutId: PropTypes.string.isRequired,
  optOutText: PropTypes.string.isRequired,
  title: PropTypes.string,
  onAnswer: PropTypes.func.isRequired
};

export default ExhibitorConsent;
